import { render, staticRenderFns } from "./TradeEditor.vue?vue&type=template&id=b6d5c2d6&"
import script from "./TradeEditor.vue?vue&type=script&lang=ts&"
export * from "./TradeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports